import { useComicActions } from '@remote-hooks';
import { useSelector } from '@stores';
import { useState } from 'react';

export const useAdultsOnly = () => {
  // 각 항목의 접힘/펼침 상태를 관리하는 state. comic은 query string으로 핸들링
  const [sectionExpandStates, setSectionExpandStates] = useState({
    tag: true,
    sexualPosition: true
  });

  const isComicSectionExpanded = useSelector((state) => state.comic.isSectionExpanded);
  const isComicToggleOn = useSelector((state) => state.comic.isToggleOn);

  const { onSetComic } = useComicActions();

  // 항목 접기/펼치기 함수
  const handleSectionExpand = (sectionName: 'comic' | 'tag' | 'sexualPosition') => {
    if (sectionName === 'comic') {
      onSetComic({ isSectionExpanded: !isComicSectionExpanded });
    } else {
      setSectionExpandStates((prev) => ({
        ...prev,
        [sectionName]: !prev[sectionName]
      }));
    }
  };

  const handleComicSearchToggle = () => {
    // 작품 정보로 검색 항목이 접혀있고 스위치가 OFF일 시 스위치 ON으로 변경하면 항목 펼치기
    if (!isComicSectionExpanded && !isComicToggleOn) {
      onSetComic({ isSectionExpanded: true });
    }

    onSetComic({ isToggleOn: !isComicToggleOn });
  };

  return {
    sectionExpandStates,
    handleSectionExpand,

    handleComicSearchToggle,
    isComicSectionExpanded,
    isComicToggleOn
  };
};
